import styled from 'styled-components';

export const IconArea = styled.div`
  visibility: hidden;
`;
